import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { siteSettingsAPI } from '../services/api';

const SiteSettingsContext = createContext();

const defaultSettings = {
    phone: '+90 552 159 32 55',
    whatsapp: '905521593255',
    email: 'infonooraprive@gmail.com',
    address: 'Efeler mah. Şehit teğmen ihsan sezgin sokak 25/B İzmir/Buca Lak Lak Kafe Karşısı',
    instagram: '',
    twitter: '',
    linkedin: '',
    facebook: '',
    youtube: '',
    workingHours: 'Pazartesi - Cumartesi: 09:00 - 18:00',
    mapsEmbedUrl: '',
    freeShippingThreshold: '',
    shippingCost: ''
};

export function SiteSettingsProvider({ children }) {
    const [settings, setSettings] = useState(defaultSettings);
    const [loaded, setLoaded] = useState(false);

    const refreshSettings = useCallback(async () => {
        try {
            const res = await siteSettingsAPI.getAll();
            setSettings({ ...defaultSettings, ...res.data });
        } catch (e) {
            console.error('Site settings fetch error:', e);
        }
        setLoaded(true);
    }, []);

    useEffect(() => {
        refreshSettings();
    }, [refreshSettings]);

    return (
        <SiteSettingsContext.Provider value={{ settings, loaded, refreshSettings }}>
            {children}
        </SiteSettingsContext.Provider>
    );
}

export function useSiteSettings() {
    const context = useContext(SiteSettingsContext);
    if (!context) {
        return { settings: defaultSettings, loaded: false, refreshSettings: () => {} };
    }
    return context;
}
